/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SupplierRouteImport } from './routes/supplier'
import { Route as ProjectRouteImport } from './routes/project'
import { Route as CertificatesRouteImport } from './routes/certificates'
import { Route as IndexRouteImport } from './routes/index'

const SupplierRoute = SupplierRouteImport.update({
  id: '/supplier',
  path: '/supplier',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectRoute = ProjectRouteImport.update({
  id: '/project',
  path: '/project',
  getParentRoute: () => rootRouteImport,
} as any)
const CertificatesRoute = CertificatesRouteImport.update({
  id: '/certificates',
  path: '/certificates',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/certificates': typeof CertificatesRoute
  '/project': typeof ProjectRoute
  '/supplier': typeof SupplierRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/certificates': typeof CertificatesRoute
  '/project': typeof ProjectRoute
  '/supplier': typeof SupplierRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/certificates': typeof CertificatesRoute
  '/project': typeof ProjectRoute
  '/supplier': typeof SupplierRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/certificates' | '/project' | '/supplier'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/certificates' | '/project' | '/supplier'
  id: '__root__' | '/' | '/certificates' | '/project' | '/supplier'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CertificatesRoute: typeof CertificatesRoute
  ProjectRoute: typeof ProjectRoute
  SupplierRoute: typeof SupplierRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/supplier': {
      id: '/supplier'
      path: '/supplier'
      fullPath: '/supplier'
      preLoaderRoute: typeof SupplierRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project': {
      id: '/project'
      path: '/project'
      fullPath: '/project'
      preLoaderRoute: typeof ProjectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/certificates': {
      id: '/certificates'
      path: '/certificates'
      fullPath: '/certificates'
      preLoaderRoute: typeof CertificatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CertificatesRoute: CertificatesRoute,
  ProjectRoute: ProjectRoute,
  SupplierRoute: SupplierRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
